export default {
  'ff.nav.market': 'Chợ',
  'ff.market.tab.trade': 'Chợ Giao Dịch',
  'ff.market.tab.myOrders': 'Đơn Của Tôi',
  'ff.market.tab.history': 'Lịch Sử',
  'ff.market.title': 'Trade Market',
  'ff.market.badge.new': 'MỚI',
  'ff.market.subtitle': 'Chọn một vật phẩm bên dưới, sau đó bấm BUY hoặc SELL để giao dịch.',
  'ff.market.balance': 'Số dư',
  'ff.market.listHeading': 'DANH SÁCH VẬT PHẨM ĐANG GIAO DỊCH',
  'ff.market.bundleRank': 'HẠNG TRONG BUNDLE',
  'ff.market.fashionRank': 'HẠNG TRONG THỜI TRANG',
  'ff.market.avgSellPrice': 'GIÁ BÁN TRUNG BÌNH',
  'ff.market.floorPrice': 'Giá đáy',
  'ff.market.quantity': 'Số lượng',
  'ff.market.avgSold': 'TB đã bán',
  'ff.market.selecting': 'Đang chọn',
  'ff.market.sell': 'BÁN',
  'ff.market.buy': 'MUA',
  'ff.market.comingSoon': 'Sắp ra mắt',
  // My Orders tab
  'ff.market.myOrders.title': 'Đơn Của Tôi',
  'ff.market.myOrders.subtitle': 'Các giao dịch đang diễn ra. Vật phẩm/kim cương sẵn sàng sẽ có nút NHẬN.',
  'ff.market.filter.selling': 'Đang bán',
  'ff.market.filter.buying': 'Đang mua',
  'ff.market.filter.claimable': 'Chờ nhận',
  'ff.market.filter.history': 'Lịch sử của tôi',
  'ff.market.claimAll': 'Nhận tất cả',
  'ff.market.col.item': 'VẬT PHẨM',
  'ff.market.col.type': 'LOẠI',
  'ff.market.col.price': 'GIÁ',
  'ff.market.col.quantity': 'SL',
  'ff.market.col.status': 'TRẠNG THÁI',
  'ff.market.col.action': 'THAO TÁC',
  'ff.market.type.sell': 'BÁN',
  'ff.market.type.buy': 'MUA',
  'ff.market.status.selling': 'ĐANG BÁN',
  'ff.market.status.sold': 'ĐÃ BÁN',
  'ff.market.status.buying': 'ĐANG MUA',
  'ff.market.status.bought': 'ĐÃ MUA',
  'ff.market.status.claimed': 'ĐÃ NHẬN',
  'ff.market.status.cancelled': 'ĐÃ HỦY',
  'ff.market.action.cancel': 'HỦY',
  'ff.market.action.claimDiamond': 'NHẬN',
  'ff.market.action.claimItem': 'NHẬN ITEM',
  'ff.market.empty': 'Không có đơn nào',
  // Terms confirmation modal
  'ff.market.terms.title': 'ĐIỀU KHOẢN CHỢ GIAO DỊCH',
  'ff.market.terms.heading': 'MỌI GIAO DỊCH BẰNG TIỀN THẬT NGOÀI GAME ĐỀU BỊ CẤM.',
  'ff.market.terms.penalty': 'Nếu vi phạm, tài khoản của bạn sẽ bị',
  'ff.market.terms.penaltyHighlight': 'khoá vĩnh viễn',
  'ff.market.terms.disagree': 'KHÔNG ĐỒNG Ý',
  'ff.market.terms.agree': 'ĐỒNG Ý',
  // Age verification modal
  'ff.market.age.title': 'XÁC MINH TUỔI',
  'ff.market.age.badge': '16+',
  'ff.market.age.detail': 'Chợ Giao Dịch chỉ dành cho người chơi từ 16 tuổi trở lên.',
  'ff.market.age.placeholder': 'Năm sinh của bạn',
  'ff.market.age.ok': 'OK',
  'ff.market.age.invalid': 'Bạn phải từ 16 tuổi trở lên.',
  // Place order modal (buy / sell)
  'ff.market.order.buyTitle': 'ĐẶT GIÁ MUA',
  'ff.market.order.sellTitle': 'ĐẶT GIÁ BÁN',
  'ff.market.order.buyNote': 'Sau khi mua, bạn không thể bán lại vật phẩm này trong 2 tuần.',
  'ff.market.order.sellNote': 'Phí đăng bán sẽ được áp dụng khi vật phẩm được bán.',
  'ff.market.order.priceHint': 'Giá đặt theo bội số của 10. Hệ thống tự khớp listing rẻ nhất ≤ giá của bạn.',
  'ff.market.order.invalidPrice': 'Nhập giá là bội số của 10.',
  'ff.market.order.insufficient': 'Số dư không đủ.',
  'ff.market.order.balance': 'Số dư',
  'ff.market.order.cancel': 'HỦY',
  'ff.market.order.confirmBuy': 'MUA',
  'ff.market.order.confirmSell': 'BÁN',
  'ff.market.order.success': 'Đặt lệnh thành công.',
};
